import { Typography } from "@mui/material";
import React from "react";

interface Props {
  text: string;
  center?: boolean;
  component?: "div" | "span";
  variant?:
    | "body1"
    | "body2"
    | "button"
    | "caption"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "inherit"
    | "overline"
    | "subtitle1"
    | "subtitle2";
}

const Text: React.FC<Props> = (props) => {
  const { text, center, component, variant } = props;

  return (
    <Typography
      sx={{
        textAlign: !!center ? "center" : "initial",
        color: "inherit",
        fontStyle: "inherit",
      }}
      component={component ? component : "p"}
      variant={variant ?? "body1"}
    >
      {text}
    </Typography>
  );
};

export default Text;
